// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorSalesManagers = (client) => ({
    /**
     * `POST /vendor/sales-managers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersCreate
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/sales-managers", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sales-managers/:id/transfer-customers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersIdTransferCustomersCreate
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/[id]/transfer-customers/route.ts
     */
    createTransferCustomer: (id, body, query, headers) => client.fetch(buildPath("/vendor/sales-managers/:id/transfer-customers", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sales-managers/:id/transfer-escalations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersIdTransferEscalationsCreate
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/[id]/transfer-escalations/route.ts
     */
    createTransferEscalation: (id, body, query, headers) => client.fetch(buildPath("/vendor/sales-managers/:id/transfer-escalations", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/sales-managers/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersIdDelete
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/sales-managers/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/sales-managers/:id/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersIdEscalationManagerDelete
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/[id]/escalation-manager/route.ts
     */
    deleteEscalationManager: (id, body, query, headers) => client.fetch(buildPath("/vendor/sales-managers/:id/escalation-manager", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/sales-managers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersList
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/sales-managers", { method: "GET", query, headers }),
    /**
     * `GET /vendor/sales-managers/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersIdRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/sales-managers/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/sales-managers/admin`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersAdminRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/admin/route.ts
     */
    retrieveAdmin: (query, headers) => client.fetch("/vendor/sales-managers/admin", { method: "GET", query, headers }),
    /**
     * `GET /vendor/sales-managers/available`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersAvailableRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/available/route.ts
     */
    retrieveAvailable: (query, headers) => client.fetch("/vendor/sales-managers/available", { method: "GET", query, headers }),
    /**
     * `GET /vendor/sales-managers/:id/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersIdEscalationManagerRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/[id]/escalation-manager/route.ts
     */
    retrieveEscalationManager: (id, query, headers) => client.fetch(buildPath("/vendor/sales-managers/:id/escalation-manager", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/sales-managers/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersIdCreate
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/sales-managers/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sales-managers/admin`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersAdminCreate
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/admin/route.ts
     */
    updateAdmin: (body, query, headers) => client.fetch("/vendor/sales-managers/admin", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sales-managers/:id/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersIdEscalationManagerCreate
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/[id]/escalation-manager/route.ts
     */
    updateEscalationManager: (id, body, query, headers) => client.fetch(buildPath("/vendor/sales-managers/:id/escalation-manager", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sales-managers/escalation-manager/bulk`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSalesManagersEscalationManagerBulkTransferCreate
     * @source packages/modules/b2c-core/src/api/vendor/sales-managers/escalation-manager/bulk/route.ts
     */
    updateEscalationManagerBulk: (body, query, headers) => client.fetch("/vendor/sales-managers/escalation-manager/bulk", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=sales-managers.js.map